// 📄 components/common/DonutChart.tsx
// Gráfico de anillo en SVG puro (sin librerías de charts). Cada segmento se
// dibuja como un arco sobre el mismo <circle> vía stroke-dasharray/offset.
import React from 'react';

export interface DonutChartSegment {
  label: string;
  value: number;
  color: string;
}

interface DonutChartProps {
  segments: DonutChartSegment[];
  size?: number;
  strokeWidth?: number;
  centerLabel?: string;
  centerSublabel?: string;
  className?: string;
}

export default function DonutChart({
  segments,
  size = 140,
  strokeWidth = 14,
  centerLabel,
  centerSublabel,
  className = ''
}: DonutChartProps) {
  const radius = size / 2 - strokeWidth / 2;
  const circumference = 2 * Math.PI * radius;
  const center = size / 2;
  const total = segments.reduce((sum, s) => sum + s.value, 0);

  let accumulated = 0;

  return (
    <div className={`relative inline-flex items-center justify-center ${className}`} style={{ width: size, height: size }}>
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
        <circle
          cx={center}
          cy={center}
          r={radius}
          fill="none"
          stroke="var(--border, #e5e7eb)"
          strokeWidth={strokeWidth}
        />
        {total > 0 && segments.map((segment) => {
          if (segment.value <= 0) return null;
          const dashLength = (segment.value / total) * circumference;
          const gapLength = circumference - dashLength;
          const offset = -((accumulated / total) * circumference);
          accumulated += segment.value;
          return (
            <circle
              key={segment.label}
              cx={center}
              cy={center}
              r={radius}
              fill="none"
              stroke={segment.color}
              strokeWidth={strokeWidth}
              strokeDasharray={`${dashLength} ${gapLength}`}
              strokeDashoffset={offset}
              transform={`rotate(-90 ${center} ${center})`}
            />
          );
        })}
      </svg>
      {(centerLabel || centerSublabel) && (
        <div className="absolute inset-0 flex flex-col items-center justify-center text-center" style={{ fill: 'inherit' }}>
          {centerLabel && <span className="text-2xl font-bold text-white leading-tight">{centerLabel}</span>}
          {centerSublabel && <span className="text-xs text-gray-400">{centerSublabel}</span>}
        </div>
      )}
    </div>
  );
}
